import {createContext} from "react";

interface LocationProviderProps {
  geoLocation: any,
  permissions: any,
  setGeoLocation: any,
  setPermissions: any
}

export const LocationContext = createContext<Partial<LocationProviderProps>>({});